import {Component, effect, Input, Signal, signal} from '@angular/core';
import {Utils} from "../../../../shared/utils";
import {GamesService} from "../../../../services/games-service.service";
import {TeamsService} from "../../../../services/teams.service";
import {NbDialogService, NbIconModule, NbPopoverModule, NbSpinnerModule} from "@nebular/theme";
import {MatchBoardComponent} from "../match-board/match-board.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-played',
  standalone: true,
  imports: [
    TranslateModule,
    NbSpinnerModule,
    NbIconModule,
    NbPopoverModule,
    MatchBoardComponent
  ],
  templateUrl: './played.component.html',
  styleUrl: './played.component.scss'
})
export class PlayedComponent {
  selectedGroupId: string = 'A';

  loading = signal<boolean>(false);
  selectedDivisionId = signal<string>('');
  playedMatches = signal<any>({});

  @Input() triggerTabsRefresh!: Signal<string>;
  @Input() currentUserTeamIds = signal<string[]>([]);
  @Input() selectedDivisionIdSignal = signal<string>('');
  @Input() selectedGroupIdSignal = signal<string>('A');

  constructor(
    public utils: Utils,
    private gamesService: GamesService,
    protected teamsService: TeamsService, private dialogService: NbDialogService
  ) {
    effect(() => {
      const refreshTriggeredBy = this.triggerTabsRefresh();
      if (refreshTriggeredBy == 'by_played') {
        return;
      }

      const p1 = this.selectedDivisionIdSignal();
      const p2 = this.selectedGroupIdSignal();

      if (p1 && p2) {
        this.selectedDivisionId.set(p1);
        this.selectedGroupId = p2;
        this.search();
      }
    }, { allowSignalWrites: true });
  }

  search() {
    this.loading.set(true);
    this.gamesService.matchesByWeek(this.selectedDivisionId(), this.selectedGroupId, true).subscribe((playedMatches: any) => {
      this.playedMatches.set(playedMatches);
      this.loading.set(false);
    });
  }

  protected readonly Object = Object;
}
